import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '\u2212' : '+';
  return sign + '\u20b9' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}

var card = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '10px 12px' };

var OIRideRLiveM = function () {
  var [st, setSt] = useState({});
  var [busy, setBusy] = useState(false);

  var load = useCallback(function () {
    fetch(API + '/oiride-r-live/state').then(function (r) { return r.json(); })
      .then(function (d) { setSt(d || {}); }).catch(function () {});
  }, []);

  useEffect(function () {
    load();
    var id = setInterval(load, 5000);
    return function () { clearInterval(id); };
  }, [load]);

  function post(path) {
    setBusy(true);
    fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(function (r) { return r.json(); })
      .then(function () { setBusy(false); load(); })
      .catch(function () { setBusy(false); });
  }

  var cfg = st.config || {};
  var legs = (st.legs || []).filter(function (l) { return l.status === 'open'; });
  var sig = st.signal || {};
  var enabled = !!st.enabled;
  var total = st.total_pnl || 0;

  return (
    <div style={{ padding: '14px 12px 80px', color: '#e5e7eb', fontFamily: 'inherit', height: '100%', overflowY: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 17, fontWeight: 800 }}>🎯 OI Ride-R LIVE</span>
        <span style={{ fontSize: 8, fontWeight: 800, letterSpacing: 0.8, padding: '2px 6px', borderRadius: 5, background: 'rgba(239,68,68,0.14)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.4)' }}>REAL</span>
      </div>
      <div style={{ fontSize: 9, color: '#6b7a8d', marginBottom: 10 }}>
        {cfg.lots || 1}L · entry {cfg.entry_time || '09:17'} · exit {cfg.exit_time || '15:25'} · reversed, fades the signal
      </div>

      {st.halt_reason ? (
        <div style={{ ...card, borderColor: 'rgba(239,68,68,0.5)', color: '#f87171', fontSize: 10.5, marginBottom: 10 }}>
          ☠ HALT — {st.halt_reason}
        </div>
      ) : null}
      {st.day_stopped ? (
        <div style={{ ...card, borderColor: 'rgba(251,191,36,0.45)', color: '#fbbf24', fontSize: 10.5, marginBottom: 10 }}>
          Day stopped — {st.day_stopped}
        </div>
      ) : null}

      {/* Simple toggle, no confirmation — the bought wing caps the risk. */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
        <button onClick={function () { post(enabled ? '/oiride-r-live/disable' : '/oiride-r-live/enable'); }}
          disabled={busy}
          style={{
            flex: 1, fontSize: 12, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit',
            borderRadius: 8, padding: '11px 0',
            background: enabled ? 'rgba(239,68,68,0.12)' : 'rgba(34,197,94,0.12)',
            color: enabled ? '#ef4444' : '#22c55e',
            border: '1px solid ' + (enabled ? 'rgba(239,68,68,0.5)' : 'rgba(34,197,94,0.5)'),
          }}>
          {busy ? '…' : enabled ? 'Disable' : 'Enable'}
        </button>
        {st.active ? (
          <button onClick={function () { post('/oiride-r-live/exit'); }} disabled={busy}
            style={{ flex: 1, fontSize: 12, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '11px 0', background: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: '1px solid rgba(251,191,36,0.5)' }}>
            Exit now
          </button>
        ) : null}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
        <div style={{ flex: 1, ...card, textAlign: 'center' }}>
          <div style={{ fontSize: 8, fontWeight: 800, letterSpacing: 0.8, color: '#556677' }}>TOTAL P&L</div>
          <div style={{ fontSize: 17, fontWeight: 800, color: total >= 0 ? '#22c55e' : '#ef4444', marginTop: 2 }}>{fmtINR(total)}</div>
        </div>
        <div style={{ flex: 1, ...card, textAlign: 'center' }}>
          <div style={{ fontSize: 8, fontWeight: 800, letterSpacing: 0.8, color: '#556677' }}>DIRECTION</div>
          <div style={{ fontSize: 17, fontWeight: 800, marginTop: 2, color: st.direction === 'LONG' ? '#22c55e' : st.direction === 'SHORT' ? '#ef4444' : '#6b7a8d' }}>
            {st.direction || '--'}
          </div>
        </div>
        <div style={{ flex: 1, ...card, textAlign: 'center' }}>
          <div style={{ fontSize: 8, fontWeight: 800, letterSpacing: 0.8, color: '#556677' }}>SIGNAL</div>
          <div style={{ fontSize: 17, fontWeight: 800, marginTop: 2 }}>{sig.pct != null ? sig.pct + '%' : '--'}</div>
        </div>
      </div>

      <div style={{ ...card, marginBottom: 10 }}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677', marginBottom: 6 }}>
          POSITION {st.atm ? '· ATM ' + st.atm : ''}
        </div>
        {legs.length ? legs.map(function (l, i) {
          return (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '5px 0', fontSize: 11, borderBottom: i === 0 ? '1px solid #131c2b' : 'none' }}>
              <span style={{ color: l.side === 'SELL' ? '#ef4444' : '#22c55e', fontWeight: 800, minWidth: 38 }}>{l.side}</span>
              <span style={{ flex: 1 }}>{l.strike}{l.type}</span>
              <span style={{ color: '#8b98a9', fontSize: 10 }}>{l.entry_price}→{l.ltp}</span>
              <span style={{ minWidth: 66, textAlign: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(l.pnl || 0)}</span>
            </div>
          );
        }) : <div style={{ fontSize: 10.5, color: '#6b7a8d' }}>Flat — no open legs.</div>}
      </div>

      <div style={{ ...card, padding: '6px 0' }}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677', padding: '4px 12px' }}>EVENTS</div>
        {(st.events || []).length ? st.events.slice().reverse().slice(0, 25).map(function (e, i) {
          var lv = e.level || e.type;
              var c = lv === 'error' ? '#f87171' : lv === 'warning' ? '#fbbf24' : lv === 'success' ? '#22c55e' : '#8b98a9';
          return (
            <div key={i} style={{ padding: '3px 12px', fontSize: 10 }}>
              <span style={{ color: '#556677' }}>{e.time || e.ts} </span>
              <span style={{ color: c }}>{e.text || e.msg}</span>
            </div>
          );
        }) : <div style={{ fontSize: 10, color: '#6b7a8d', padding: '6px 12px' }}>No events yet.</div>}
      </div>
    </div>
  );
};

export default OIRideRLiveM;
